// assets/configurator.js

// Diese Werte werden per Liquid in Deiner Section befüllt
window.letterImageBaseUrl = window.letterImageBaseUrl || "";
window.letterData = window.letterData || {};
window.extraProducts = window.extraProducts || [];

document.addEventListener("DOMContentLoaded", () => {
  // --- Element-Referenzen ---
  const nameInput = document.getElementById("nameInput");
  const previewContainer = document.getElementById("previewContainer");
  const addToCartButton = document.getElementById("addToCartButton");
  const nameError = document.getElementById("nameError");
  const colorError = document.getElementById("colorError");
  const umlautInfo = document.getElementById("umlautInfo");

  // --- State ---
  let letterVariants = JSON.parse(
    sessionStorage.getItem("letterVariants") || "{}"
  );
  const extraQuantities = {};
  const extraProducts = window.extraProducts;

  // --- "Schreib uns" Button einfügen ---
  const notAvailBtn = document.createElement("a");
  notAvailBtn.id = "notAvailableBtn";
  notAvailBtn.className = "btn-not-available";
  notAvailBtn.textContent = "Farbe nicht verfügbar? Schreib uns";
  notAvailBtn.href = "#";
  notAvailBtn.addEventListener("click", (e) => {
    e.preventDefault();
    const text = nameInput.value;

    const lines = [];
    lines.push("Hallo,");
    lines.push("ich würde gerne die folgenden Farben bestellen, leider sind diese aktuell nicht verfügbar:");
    lines.push("");
    lines.push("(Bitte setzt ein X in die Klammern neben der jeweiligen Wunschfarbe.)");
    lines.push("");

    if (text.trim()) {
      lines.push("Wunschname: " + text);
      lines.push("");
      text.replace(/\s/g, "").split("").forEach((letter) => {
        let norm = letter === "-" ? "bindestrich" : letter.toLowerCase();
        if ("ÄÖÜäöü".includes(letter)) norm = letter.normalize("NFD")[0].toLowerCase();
        const variants = window.letterData[norm] || [];
        const farben = variants
          .map(v => "[ ] " + v.color.charAt(0).toUpperCase() + v.color.slice(1))
          .join("       ");
        lines.push(letter + "  →  " + farben);
      });
    }

    lines.push("");
    lines.push("Bitte benachrichtigt mich sobald die obige Konfiguration wieder verfügbar ist!");

    const msg = encodeURIComponent(lines.join("\n"));
    window.location.href = "/pages/contact?contact[body]=" + msg;
  });
  addToCartButton.parentNode.insertBefore(notAvailBtn, addToCartButton.nextSibling);

  // --- Helfer-Funktionen ---
  function sanitizeColorName(name) {
    return name
      .toLowerCase()
      .trim()
      .replace(/ä/g, "ae")
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss")
      .replace(/\s+/g, "");
  }

  function createSpaceBox() {
    const div = document.createElement("div");
    div.className = "letter-preview space";
    div.innerHTML = "&nbsp;";
    return div;
  }

  function createLetterBox(letter, index) {
    if (!letter.trim()) return document.createDocumentFragment();
    let norm = letter === "-" ? "bindestrich" : letter.toLowerCase();
    if ("ÄÖÜäöü".includes(letter))
      norm = letter.normalize("NFD")[0].toLowerCase();

    const container = document.createElement("div");
    container.className = "letter-preview" + (letter === "-" ? " hyphen" : "");

    const img = document.createElement("img");
    img.alt = letter;
    img.src = `${window.letterImageBaseUrl}letter-${norm}-neutral.png`;
    const fallback = document.createElement("span");
    fallback.textContent = letter;
    fallback.className = "fallback";
    fallback.style.display = "none";
    img.onerror = () => {
      img.style.display = "none";
      fallback.style.display = "block";
    };
    img.onload = () => {
      fallback.style.display = "none";
      img.style.display = "block";
    };
    container.append(img, fallback);

    const radios = document.createElement("div");
    radios.className = "radio__buttons";
    const variants = window.letterData[norm] || [];
    if (!variants.length) {
      radios.textContent = "Keine Optionen";
    } else {
      variants.forEach((v) => {
        const id = `letter-${index}-${v.variantId}`;
        const input = document.createElement("input");
        input.type = "radio";
        input.name = `letter-${index}`;
        input.id = id;
        input.value = v.variantId;
        if (!v.available) input.disabled = true;

        const label = document.createElement("label");
        label.htmlFor = id;
        label.className = "swatch__button";
        const tooltip = document.createElement("div");
        tooltip.className = "tooltip-custom";
        tooltip.textContent = v.color.charAt(0).toUpperCase() + v.color.slice(1);
        label.append(tooltip);

        if (!v.available) label.classList.add("sold-out");
        if (v.swatch_image)
          label.style.backgroundImage = `url(${v.swatch_image})`;
        else if (v.swatch_color) label.style.backgroundColor = v.swatch_color;
        else label.style.backgroundColor = v.color;

        // Wiederherstellung
        if (letterVariants[index] == v.variantId) {
          input.checked = true;
          label.classList.add("selected");
          img.src = `${window.letterImageBaseUrl}letter-${norm}-${sanitizeColorName(v.color)}.png`;
        }

        input.addEventListener("change", () => {
          if (!input.checked) return;
          letterVariants[index] = v.variantId;
          sessionStorage.setItem("letterVariants", JSON.stringify(letterVariants));
          radios.querySelectorAll(".swatch__button").forEach((b) => b.classList.remove("selected"));
          label.classList.add("selected");
          img.src = `${window.letterImageBaseUrl}letter-${norm}-${sanitizeColorName(v.color)}.png`;
          validateConfiguration();
        });

        radios.append(input, label);
      });
    }
    container.append(radios);
    return container;
  }

  function renderPreview() {
    const text = nameInput.value;
    previewContainer.innerHTML = "";
    let idx = 0;

    if (window.innerWidth < 750) {
      let row = document.createElement("div");
      row.className = "preview-row";
      for (const ch of text) {
        if (ch === " ") {
          previewContainer.append(row);
          row = document.createElement("div");
          row.className = "preview-row";
          continue;
        }
        row.append(createLetterBox(ch, idx++));
        if (row.childNodes.length === 2) {
          previewContainer.append(row);
          row = document.createElement("div");
          row.className = "preview-row";
        }
      }
      if (row.childNodes.length) previewContainer.append(row);
    } else {
      const tokens = text.split(/(\s|-)/).filter((t) => t);
      const boxes = [];
      tokens.forEach((t) => {
        if (/^\s+$/.test(t)) boxes.push(createSpaceBox());
        else if (t === "-") boxes.push(createLetterBox("-", idx++));
        else t.split("").forEach((ch) => boxes.push(createLetterBox(ch, idx++)));
      });

      const cw = previewContainer.offsetWidth, bw = 155;
      const rows = [];
      let row = [];
      boxes.forEach((box) => {
        if ((row.length + 1) * bw <= cw) {
          row.push(box);
        } else {
          let split = -1, isHy = false;
          for (let j = row.length - 1; j >= 0; j--) {
            if (row[j].classList.contains("space") || row[j].classList.contains("hyphen")) {
              split = j;
              isHy = row[j].classList.contains("hyphen");
              break;
            }
          }
          if (split >= 0) {
            let toPush = isHy ? row.slice(0, split + 1) : row.slice(0, split);
            while (toPush.length && toPush[toPush.length - 1].classList.contains("space")) toPush.pop();
            if (toPush.length) rows.push(toPush);
            row = row.slice(split + 1);
            while (row.length && row[0].classList.contains("space")) row.shift();
            row.push(box);
          } else {
            rows.push(row);
            row = [box];
          }
        }
      });
      if (row.length) {
        while (row.length && row[row.length - 1].classList.contains("space")) row.pop();
        if (row.length) rows.push(row);
      }
      rows.forEach((r) => {
        const div = document.createElement("div");
        div.className = "preview-row";
        r.forEach((b) => div.append(b));
        previewContainer.append(div);
      });
    }

    umlautInfo.style.display = /[ÄÖÜäöü]/.test(text) ? "block" : "none";
    validateConfiguration();
  }

  function validateConfiguration() {
    const txt = nameInput.value.replace(/\s/g, "");
    const ok = txt.length > 0 && txt.split("").every((_, i) => letterVariants[i]);
    colorError.style.display = ok ? "none" : "block";
    addToCartButton.disabled = !ok;
    addToCartButton.classList.toggle("disabled", !ok);

    const extrasSec = document.getElementById("extrasSection");
    if (extrasSec) {
      extrasSec.style.display = ok ? "block" : "none";
    }

    return ok;
  }

  function initExtras() {
    const section = document.getElementById("extrasSection");
    if (!section) return;
    section.querySelectorAll(".extras-item").forEach(item => {
      const handle = item.dataset.handle;
      extraQuantities[handle] = 0;
      const minus = item.querySelector(".quantity__minus");
      const plus  = item.querySelector(".quantity__plus");
      const inp   = item.querySelector(".quantity__input");
      minus.addEventListener("click", () => {
        extraQuantities[handle] = Math.max(0, extraQuantities[handle] - 1);
        inp.value = extraQuantities[handle];
      });
      plus.addEventListener("click", () => {
        extraQuantities[handle] = Math.min(99, extraQuantities[handle] + 1);
        inp.value = extraQuantities[handle];
      });
    });
  }

  function bindAddToCart() {
    addToCartButton.addEventListener("click", () => {
      if (nameInput.value.length > 15) {
        nameError.style.display = "block";
        return;
      }
      if (!validateConfiguration()) return;
      const items = nameInput.value
        .replace(/\s/g, "")
        .split("")
        .map((_, i) => ({
          id: letterVariants[i],
          quantity: 1,
        }))
        .reverse();

      window.extraProducts.forEach(p => {
        const q = extraQuantities[p.handle] || 0;
        if (q > 0) items.push({ id: p.variantId, quantity: q });
      });
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      })
        .then((r) => r.json())
        .then((_) => (location.href = "/cart"))
        .catch((_) => alert("Fehler beim Hinzufügen zum Warenkorb."));
    });
  }

  // --- Listener & Init ---
  nameInput.addEventListener("input", () => {
    nameInput.value = nameInput.value.toUpperCase().replace(/[^A-ZÄÖÜ \-]/g, "");
    nameError.style.display = nameInput.value.length > 15 ? "block" : "none";
    renderPreview();
  });

  window.addEventListener("resize", renderPreview);

  renderPreview();
  validateConfiguration();
  initExtras();
  bindAddToCart();
});